import { Box } from "@mui/material";
import PaginationControls from "components/fileStorage/PaginationControls";

type Props = {
  page: number;
  pageSize: number;
  total: number;
  disabled?: boolean;
  onPageChange: (page: number) => void;
  /** Callers reset to page 1 themselves when the size changes. */
  onPageSizeChange: (pageSize: number) => void;
};

/** The paginator slotted under a run-history table; hidden while empty. */
export default function RunsPagination({
  page,
  pageSize,
  total,
  disabled = false,
  onPageChange,
  onPageSizeChange,
}: Props) {
  if (total <= 0) return null;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  return (
    <Box
      sx={{
        position: "relative",
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      <PaginationControls
        currentLimit={pageSize}
        onLimitChange={onPageSizeChange}
        totalItems={total}
        currentPage={page}
        totalPages={totalPages}
        onPageChange={onPageChange}
        showLimitSelector={true}
        showPageInfo={true}
        disabled={disabled}
        size="small"
        pageTokens={[]}
        hasNextPage={page < totalPages}
        borderStyle={{ borderTop: "none", borderColor: "none" }}
        buttonStyle={{ border: "1px solid", borderColor: "divider" }}
      />
    </Box>
  );
}
